export default "__VITE_ASSET__B9B0mEJ$__"